import { message } from 'antd';
import { useEffect, useState } from 'react';
import { FilesService } from '../../services';
import { isObjectEmpty } from '../../utils/commonUtils';
import getFileObjectName from '../../utils/uploadFile';

const useGetImageDocument = (params = {}, onSuccess, onFailed) => {
  const bucketName = params?.bucket_name || null;
  const objectName = params?.object_name || null;

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if (!isObjectEmpty(params)) {
      setIsLoading(true);
      FilesService.downloadReq({
        bucket_name: bucketName,
        object_name: objectName,
      })
        .then((res) => {
          setData(res.data);
          if (onSuccess) {
            onSuccess(res?.data);
          }
        })
        .catch((err) => {
          if (onFailed) {
            onFailed(err);
          }
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [bucketName, objectName, params, onSuccess, onFailed]);

  const url = data?.url || '';
  return {
    url,
    loading: isLoading,
  };
};

const useGetImageDocumentArray = (params) => {
  const { documents = [], onCompleted, onError, skip = true } = params;
  const [data, setData] = useState([]);

  async function axiosWrapper(item) {
    const itemPromise = FilesService.downloadReq({
      bucket_name: item?.bucket_name,
      object_name: item?.object_name,
    }).then((res) => {
      return { image: res?.data?.url };
    });
    const axiosResult = await itemPromise;
    return axiosResult;
  }

  useEffect(() => {
    async function mapWrapper(arr) {
      const promiseArray = arr.map((item) => {
        return axiosWrapper(item);
      });

      await Promise.all(promiseArray)
        .then((res) => {
          setData(res);
          if (onCompleted) onCompleted(res);
        })
        .catch((err) => {
          if (onError) onError(err);
        });
    }
    if (!skip) mapWrapper(documents || []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skip, documents]);

  return { data };
};

const useCustomRequest = () => {
  const [fileUpload, setFileUpload] = useState({});
  const [isLoadingUpload, setIsLoadingUpload] = useState(false);
  const [objectName, setObjectName] = useState('');
  const [pocImage, setPocImage] = useState(null);

  const customRequest = async (options, withMessageSuccess = true) => {
    const { file } = options;
    const { uid } = file;
    setFileUpload(file);
    try {
      setIsLoadingUpload(true);
      const resUploadReq = await FilesService.uploadReq({
        bucket_name: 'public',
        object_name: uid,
      });
      const { url } = resUploadReq.data;
      const fileObjectName = getFileObjectName(url);
      setObjectName(fileObjectName);
      await FilesService.uploadFile(url, file);
      const body = {
        bucket_name: 'public',
        object_name: fileObjectName,
      };
      const resDownloadReq = await FilesService.downloadReq(body);
      const { url: urlImage } = resDownloadReq.data;
      setPocImage(urlImage);
      if (withMessageSuccess) {
        message.success('Successful upload file');
      }
      return { ...body, url: urlImage };
    } catch {
      message.error('Unsuccessful upload file');
      return null;
    } finally {
      setIsLoadingUpload(false);
    }
  };

  return {
    customRequest,
    fileUpload,
    isLoadingUpload,
    objectName,
    pocImage,
    setFileUpload,
  };
};

export default {
  useGetImageDocument,
  useCustomRequest,
  useGetImageDocumentArray,
};
